import React from "react";
import ScreenService from "../../services/ScreenService";
import { getModel } from "../../utils/models";

const BrandInfo = ({ coBrandedLogo }) => {
    const model = getModel();
    const positioningClass = ScreenService.isVertical ? "brand-info-positioning-vertical" : "brand-info-positioning-horizontal";
    if (model === "xi6" || model === "xid" || model === "xg2v2") {
        return (
            <div className={`${positioningClass} brand-info-container`}>
                <img width={200} src="https://cdn.upshow.tv/ui-assets/EverPass_Horizontal_All_White.png" alt="EverPass logo" />
                <div className="separator co-branded-separator"></div>
                {coBrandedLogo && <img width={200} src={coBrandedLogo} alt="Co Branded logo" />}
            </div>
        );
    }
    return null;
};

export default BrandInfo;
